<slotcom-legal-layout [modalName]="NonPersistedModalName.TermsComponent">
  <div class="e-title">{{ 'legal.terms.title' | translate | uppercase }}</div>

  <!-- 1. Aviso Legal -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.legal-notice.title' | translate"></div>
  <p [innerHTML]="'legal.terms.legal-notice.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.legal-notice.p-2' | translate"></p>

  <!-- 2. Objeto y ámbito de aplicación de las condiciones generales -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.purpose.title' | translate"></div>
  <p [innerHTML]="'legal.terms.purpose.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.purpose.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.purpose.p-3' | translate"></p>
  <p [innerHTML]="'legal.terms.purpose.p-4' | translate"></p>

  <!-- 3. Acceso a la página web -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.web-access.title' | translate"></div>
  <p [innerHTML]="'legal.terms.web-access.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.web-access.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.web-access.p-3' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.terms.web-access.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.terms.web-access.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.terms.web-access.list.l-3' | translate"></li>
    <li [innerHTML]="'legal.terms.web-access.list.l-4' | translate"></li>
  </ul>
  <p [innerHTML]="'legal.terms.web-access.p-4' | translate"></p>
  <p [innerHTML]="'legal.terms.web-access.p-5' | translate"></p>

  <!-- 4. Menores -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.youngers.title' | translate"></div>
  <p [innerHTML]="'legal.terms.youngers.p-1' | translate"></p>

  <!-- 5. Condiciones de uso de la web -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.web-conditions.title' | translate"></div>
  <p [innerHTML]="'legal.terms.web-conditions.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.web-conditions.p-2' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.terms.web-conditions.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list.l-3' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list.l-4' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list.l-5' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list.l-6' | translate"></li>
  </ul>
  <p [innerHTML]="'legal.terms.web-conditions.p-3' | translate"></p>
  <p [innerHTML]="'legal.terms.web-conditions.p-4' | translate"></p>
  <p [innerHTML]="'legal.terms.web-conditions.p-5' | translate"></p>
  <p [innerHTML]="'legal.terms.web-conditions.p-6' | translate"></p>
  <p [innerHTML]="'legal.terms.web-conditions.p-7' | translate"></p>
  <p [innerHTML]="'legal.terms.web-conditions.p-8' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.terms.web-conditions.list-2.l-1' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list-2.l-2' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list-2.l-3' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list-2.l-4' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list-2.l-5' | translate"></li>
    <li [innerHTML]="'legal.terms.web-conditions.list-2.l-6' | translate"></li>
  </ul>

  <!-- 6. Juegos disponibles en la web -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.available-games.title' | translate"></div>
  <p [innerHTML]="'legal.terms.available-games.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.available-games.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.available-games.p-3' | translate"></p>

  <!-- 7. Registro -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.registration.title' | translate"></div>
  <p [innerHTML]="'legal.terms.registration.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.registration.p-2' | translate"></p>

  <!-- 8. Cuenta de usuario -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.user-account.title' | translate"></div>
  <p [innerHTML]="'legal.terms.user-account.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.user-account.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.user-account.p-3' | translate"></p>
  <p [innerHTML]="'legal.terms.user-account.p-4' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.terms.user-account.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.terms.user-account.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.terms.user-account.list.l-3' | translate"></li>
    <li [innerHTML]="'legal.terms.user-account.list.l-4' | translate"></li>
    <li [innerHTML]="'legal.terms.user-account.list.l-5' | translate"></li>
    <li [innerHTML]="'legal.terms.user-account.list.l-6' | translate"></li>
  </ul>
  <p [innerHTML]="'legal.terms.user-account.p-5' | translate"></p>
  <p [innerHTML]="'legal.terms.user-account.p-6' | translate"></p>
  <ol>
    <li [innerHTML]="'legal.terms.user-account.delete-account-steps.step-1' | translate"></li>
    <li [innerHTML]="'legal.terms.user-account.delete-account-steps.step-2' | translate"></li>
    <li [innerHTML]="'legal.terms.user-account.delete-account-steps.step-3' | translate"></li>
    <li [innerHTML]="'legal.terms.user-account.delete-account-steps.step-4' | translate"></li>
    <li [innerHTML]="'legal.terms.user-account.delete-account-steps.step-5' | translate"></li>
  </ol>
  <p [innerHTML]="'legal.terms.user-account.p-7' | translate"></p>
  <p [innerHTML]="'legal.terms.user-account.p-8' | translate"></p>

  <!-- 9. App SLOT.COM - Tragaperras gratis -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.app.title' | translate"></div>
  <p [innerHTML]="'legal.terms.app.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.app.p-2' | translate"></p>

  <!-- 10. Proceso de compra -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.buy-process.title' | translate"></div>
  <p [innerHTML]="'legal.terms.buy-process.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.buy-process.p-2' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.terms.buy-process.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.terms.buy-process.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.terms.buy-process.list.l-3' | translate"></li>
  </ul>

  <!-- 11. Monedas o bienes virtuales -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.coins-gems.title' | translate"></div>
  <p [innerHTML]="'legal.terms.coins-gems.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.coins-gems.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.coins-gems.p-3' | translate"></p>
  <p [innerHTML]="'legal.terms.coins-gems.p-4' | translate"></p>
  <p [innerHTML]="'legal.terms.coins-gems.p-5' | translate"></p>
  <p [innerHTML]="'legal.terms.coins-gems.p-6' | translate"></p>

  <!-- 12. Precios -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.prices.title' | translate"></div>
  <p [innerHTML]="'legal.terms.prices.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.prices.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.prices.p-3' | translate"></p>

  <!-- 13. Forma de pago -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.payment-method.title' | translate"></div>
  <p [innerHTML]="'legal.terms.payment-method.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.payment-method.p-2' | translate"></p>

  <!-- 14. Derecho de desistimiento -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.right-of-withdrawal.title' | translate"></div>
  <p [innerHTML]="'legal.terms.right-of-withdrawal.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.right-of-withdrawal.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.right-of-withdrawal.p-3' | translate"></p>

  <!-- 15. Atención al usuario -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.user-support.title' | translate"></div>
  <p [innerHTML]="'legal.terms.user-support.p-1' | translate"></p>

  <!-- 16. Derechos de propiedad intelectual e industrial -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.property-rights.title' | translate"></div>
  <p [innerHTML]="'legal.terms.property-rights.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.property-rights.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.property-rights.p-3' | translate"></p>
  <p [innerHTML]="'legal.terms.property-rights.p-4' | translate"></p>

  <!-- 17. Responsabilidades y garantías -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.responsabilities-guarantees.title' | translate"></div>
  <p [innerHTML]="'legal.terms.responsabilities-guarantees.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.responsabilities-guarantees.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.responsabilities-guarantees.p-3' | translate"></p>
  <p [innerHTML]="'legal.terms.responsabilities-guarantees.p-4' | translate"></p>
  <p [innerHTML]="'legal.terms.responsabilities-guarantees.p-5' | translate"></p>
  <p [innerHTML]="'legal.terms.responsabilities-guarantees.p-6' | translate"></p>

  <!-- 18. Enlaces -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.links.title' | translate"></div>
  <p [innerHTML]="'legal.terms.links.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.links.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.links.p-3' | translate"></p>
  <p [innerHTML]="'legal.terms.links.p-4' | translate"></p>
  <p [innerHTML]="'legal.terms.links.p-5' | translate"></p>
  <p [innerHTML]="'legal.terms.links.p-6' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.terms.links.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.terms.links.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.terms.links.list.l-3' | translate"></li>

    <ul>
      <li [innerHTML]="'legal.terms.links.list.sublist.sl-1' | translate"></li>
      <li [innerHTML]="'legal.terms.links.list.sublist.sl-2' | translate"></li>
      <li [innerHTML]="'legal.terms.links.list.sublist.sl-3' | translate"></li>
    </ul>

    <li [innerHTML]="'legal.terms.links.list.l-4' | translate"></li>

    <ul>
      <li [innerHTML]="'legal.terms.links.list.sublist-2.sl2-1' | translate"></li>
      <li [innerHTML]="'legal.terms.links.list.sublist-2.sl2-2' | translate"></li>
    </ul>
  </ul>

  <!-- 19. Protección de datos -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.data-protection.title' | translate"></div>
  <p [innerHTML]="'legal.terms.data-protection.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.data-protection.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.data-protection.p-3' | translate"></p>
  <p [innerHTML]="'legal.terms.data-protection.p-4' | translate"></p>

  <!-- 20. Duración y modificación -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.duration-modification.title' | translate"></div>
  <p [innerHTML]="'legal.terms.duration-modification.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.duration-modification.p-2' | translate"></p>

  <!-- 21. Reclamaciones y quejas -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.claims-complaints.title' | translate"></div>
  <p [innerHTML]="'legal.terms.claims-complaints.p-1' | translate"></p>

  <!-- 22. Generalidades -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.terms.generalities.title' | translate"></div>
  <p [innerHTML]="'legal.terms.generalities.p-1' | translate"></p>
  <p [innerHTML]="'legal.terms.generalities.p-2' | translate"></p>
  <p [innerHTML]="'legal.terms.generalities.p-3' | translate"></p>
  <p [innerHTML]="'legal.terms.generalities.p-4' | translate"></p>

  <!-- Última version -->
  <p
    class="e-lastVersion"
    [innerHTML]="'legal.terms.last-version.p-1' | translate"></p>
</slotcom-legal-layout>
